import Resource from './Resource'

class PaymentCard extends Resource {
  constructor(data) {
    super(data)
  }

  get id() {
    return this.data._id
  }

  get type() {
    return this.data.type
  }

  get lastFour() {
    return this.data.last_four
  }

  get nameOnCard() {
    return this.data.name_on_card
  }

  get pan() {
    return this.data.pan
  }

  set pan(val) {
    return this.data.pan = val
  }

  get cvv() {
    return this.data.cvv
  }

  set cvv(val) {
    return this.data.cvv = val
  }

  get firstName() {
    return this.data.first_name
  }

  set firstName(val) {
    return this.data.first_name = val
  }

  get lastName() {
    return this.data.last_name
  }

  set lastName(val) {
    return this.data.last_name = val
  }

  get expiry() {
    return this.data.expiry
  }

  set expiry(val) {
    return this.data.expiry = val.replace(/\s+/g, '')
  }

  get friendlyName() {
    return this.data.friendly_name
  }

  set friendlyName(val) {
    return this.data.friendly_name = val
  }
}

export default PaymentCard
